import { useCallback, useSyncExternalStore } from 'react';

/**
 * Consulta de media query reativa.
 *
 * Serve para trocar de estrutura (tabela ↔ cartões), não para esconder
 * conteúdo: o formulário de projeto e as atualizações precisam ser plenamente
 * utilizáveis a partir de 375px (RNF-U02). Mobile é caso de uso real, não
 * degradação aceitável.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  // No servidor não há matchMedia; assumimos desktop (falso) como padrão.
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** Breakpoint `md` do Tailwind. Abaixo disso, prefira listas a tabelas. */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
